import { render } from "./reportWaiterNameBill.vue?vue&type=template&id=04c13385"
import script from "./reportWaiterNameBill.vue?vue&type=script&lang=js"
export * from "./reportWaiterNameBill.vue?vue&type=script&lang=js"

import "./reportWaiterNameBill.vue?vue&type=style&index=0&id=04c13385&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__